<template>
  <v-app id="login" :style="style">
    <v-main>
      <!-- EN DRAWER -->
      <!-- <v-navigation-drawer
        v-model="expand"
        absolute
        permanent
        right
        width="30%"
        style="padding:20px;background-color: rgb(255 255 255 / 55%); "
      >
        <v-img
          :src="require('@/assets/C_RGB APP.png')"
          max-height="300px"
          max-width="300px"
          position="center"
          style="margin:auto"
        ></v-img>
        <v-form @submit="login" style="    text-align: right;align-self: center;">
          <v-text-field
            label="E-mail"
            name="login"
            regular
            color="primary"
            prepend-inner-icon="mdi-account"
            v-model="user"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="password"
            id="password"
            color="primary"
            label="Contraseña"
            regular
            name="password"
            prepend-inner-icon="mdi-lock"
            type="password"
            @keyup.enter="login"
          ></v-text-field>
          <v-btn color="primary" x-large outlined @click="login" right>Acceder</v-btn>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-navigation-drawer>-->

      <!--  -->
      <v-container style="margin-top: 5%;" fluid v-if="true">
        <v-row justify="center">
          <v-col
            cols="4"
            style="  background-color: rgb(255 255 255 / 60%);border-radius: 5%;padding:20px"
          >
            <v-img
              :src="require('@/assets/C_RGB APP.png')"
              max-height="250px"
              max-width="250px"
              position="center"
              style="margin:auto"
            ></v-img>
            <v-form @submit="login" style="text-align:center">
              <!-- <v-row>
              <v-col cols="5">-->
              <v-text-field
                label="E-mail"
                name="login"
                rounded
                outlined
                background-color="white"
                prepend-inner-icon="mdi-account"
                v-model="user"
                type="text"
              ></v-text-field>
              <!-- </v-col>
              <v-col justify="end" cols="5">-->
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-model="password"
                    id="password"
                    rounded
                    label="Contraseña"
                    outlined
                    background-color="white"
                    name="password"
                    prepend-inner-icon="mdi-lock"
                    type="password"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-btn color="primary" block rounded x-large @click="login">Entrar</v-btn>
                </v-col>
              </v-row>
              <!-- <v-subheader class="my-0">
                <a>No estás registrado?</a>
              </v-subheader>-->
              <!-- </v-col>
              <v-col>-->
              <!-- <v-row class="align-center">
                <v-col>
                  <v-btn color="primary" disabled x-large @click="login">Regístrate</v-btn>
                </v-col>
                <v-col>
                  <v-btn color="primary" x-large outlined @click="login">Entrar</v-btn>
                </v-col>
              </v-row>-->
              <!-- </v-col>
              </v-row>-->
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { CREDENTIALS } from "@/quickblox/config";
import AuthService from "@/service/auth_service";

console.log(CREDENTIALS);
export default {
  data() {
    return {
      user: null,
      password: null
      // token: this.$store.state.token,
      // auth: auth
    };
  },
  async created() {
    // console.log("beforeMount");
    // if (this.$store.state.token != null) {
    //   this.$QB.init(this.$store.state.token, CREDENTIALS.appId);
    //   this.createSession();
    // } else {
    //   this.$QB.init(
    //     CREDENTIALS.appId,
    //     CREDENTIALS.authKey,
    //     CREDENTIALS.authSecret
    //   );
    //   console.log(CREDENTIALS);
    // }
  },
  computed: {
    style() {
      let width = 600;
      let height = 450;
      if (parseInt(window.innerWidth / 2) < 600) {
        width = parseInt(window.innerWidth / 2);
      }
      if (parseInt(window.innerHeight / 2) < 450) {
        height = parseInt(window.innerHeight / 2);
      }
      return (
        "background-image: url('https://source.unsplash.com/featured/" +
        width +
        "x" +
        height +
        "/?pet'); background-size:cover ; background-repeat: no-repeat;"
      );
    }
  },

  methods: {
    async login() {
      console.log("login");
      await AuthService.logIn(this.user, this.password);

      // this.auth
      //   .signInWithEmailAndPassword(this.user, this.password)
      //   .then(response => {
      //     console.log(response);
      //     // params.password = "kdfqKCYopn2ApPza6cwx";
      //     // this.$QB.createSession(params, (err, res) => {
      //     //   // callback function

      //     //   if (err) {
      //     //     console.log(err, res);
      //     //   }
      //     //   console.log(res);
      //     //   this.$store.commit("setToken", res.token);
      //     //   this.$store.commit("setUserId", response.user.uid);

      //     //   this.connect();
      //     //   //this.logIn();
      //     // });
      //   })
      //   .catch(function(error) {
      //     // Handle Errors here.

      //     console.log(error);
      //     // ...
      //   });

      // this.$QB.createSession(
      //   {
      //     login: this.auth.currentUser.email,
      //     password: "kdfqKCYopn2ApPza6cwx"
      //   },
      //   (err, res) => {
      //     // callback function

      //     if (err) {
      //       console.log(err, res);
      //     }
      //     console.log(res);
      //     this.$store.commit("setToken", res.token);
      //     this.$store.commit("setUserId", response.user.uid);

      //     this.connect();
      //     //this.logIn();
      //   }
      // );
      // });
    },
    createSession() {
      // this.$QB.getSession((err, res) => {
      //   if (!err) {
      //     this.$store.commit("setToken", res.session.token);
      //   }
      // });
    },
    logIn() {
      // var params = {
      //   login: this.login,
      //   password: "kdfqKCYopn2ApPza6cwx",
      //   token: this.$store.state.token
      // };
      // this.$QB.login(params, (err, res) => {
      //   this.userId = res.id;
      //   this.retreiveDialogs();
      //   this.connect();
      // });
    },
    connect() {
      // if (this.$store.state.token) {
      //   var userCredentials = {
      //     userId: this.userId,
      //     password: this.$store.state.token
      //   };
      //   userCredentials = {
      //     userId: this.userId,
      //     password: this.password,
      //     token: this.$store.state.token
      //   };
      //   this.$QB.chat.connect(userCredentials, function(error, contactList) {
      //     if (error) {
      //       console.log(error, contactList);
      //     }
      //     this.contactList = contactList;
      //   });
      // }
    }
  }
};
</script>

<style>
.v-navigation-drawer__content {
  align-self: center;
}
</style>